/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

/*
* Hide badge on sibling swatch mouseover
*
*/

document.addEventListener('mouseover', (event) => {
  const siblingSwatch = event.target.closest('[data-sibling-link]');
  if (!siblingSwatch) return;

  const siblingLink = siblingSwatch.querySelector('.sibling__link');
  if (!siblingLink || siblingLink.classList.contains('sibling__link--current')) return;

  siblingSwatch.closest('.product-item')?.classList.add('hide-badge-box');
});

document.addEventListener('mouseout', (event) => {
  const siblingSwatch = event.target.closest('[data-sibling-link]');
  if (!siblingSwatch) return;

  siblingSwatch.closest('.product-item')?.classList.remove('hide-badge-box');
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

